import React, { useEffect, useState } from "react";
import { SidebarDataElectronicBilling } from "./SidebarDataElectronicBilling";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import FooterSidebar from "./FooterSidebar";
import { handleSidebarOptions } from "./mainFunctions";
import PropTypes from 'prop-types';

const canShowMenuItem = (item, isAdmin) => isAdmin || !item.adminOnly;

const buildMenuData = (isAdmin) => SidebarDataElectronicBilling
  .filter(item => canShowMenuItem(item, isAdmin))
  .map(item => ({
    ...item,
    isClicked: false,
    subNav: item.subNav ? item.subNav.filter(subItem => canShowMenuItem(subItem, isAdmin)) : undefined
  }))
  .filter(item => !item.subNav || item.subNav.length > 0);

const SidebarElectronicBilling = ({isAdmin}) => {
  const [openMenu, setOpenMenu] = useState(null);
  const [menuData, setMenuData] = useState(buildMenuData(isAdmin));

  useEffect(() => {
    setOpenMenu(null);
    setMenuData(buildMenuData(isAdmin));
  }, [isAdmin]);

  useEffect(() => {
    function handleResize() {
      let nav = document.querySelector("#nav-top").offsetHeight;
      let contentDiv = document.querySelector("#contentElectronicBilling");
      let altura = window.innerHeight - nav;
      contentDiv.style.height = altura + "px";
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuClick = (id,event,isFromSubMenu) => {
	handleSidebarOptions(event,isFromSubMenu);

    setMenuData(prevMenu =>
      prevMenu.map(menu =>
        menu.id === id
          ? { ...menu, isClicked: true, className: 'active' }
          : { ...menu, isClicked: false, className: '' }
      )
    );
    setOpenMenu(prevMenu => (prevMenu === id ? null : id));
  };

  return (
    <IconContext.Provider value={{ color: "#fff" }}>
      <ul className="ulSidebar" id="ulSidebar">
        {menuData.map((item, index) => (
          <SubMenu
            item={item}
            key={index}
            openMenu={openMenu}
            setOpenMenu={setOpenMenu}
            handleMenuClick={handleMenuClick}
          />
        ))}
      </ul>
      <FooterSidebar url="electronicBilling" />
    </IconContext.Provider>
  );
};

SidebarElectronicBilling.propTypes = {
  isAdmin: PropTypes.bool
};

export default SidebarElectronicBilling;
